<template>
  <div id="home">
  </div>
</template>

<script>
export default {
  data () {
    return {
        title: 'Home',
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Home.vue